export default "__VITE_ASSET__D7yOVg2E__"